import { Controller } from "@hotwired/stimulus"
import lottie from "lottie-web"

import Stimulus from "../utils/stimulus"

class Animation extends Controller {
  static targets = [`stage`]
  static values = { name: String, loop: Boolean, autoplay: Boolean }
  #animation

  connect() {
    if (!this.hasNameValue) return

    this.#animation = lottie.loadAnimation({
      container: this.element,
      renderer: `svg`,
      loop: this.loopValue,
      autoplay: this.autoplayValue,
      path: `/animations/${this.nameValue}.json`,
    })
  }

  disconnect() {
    this.#animation?.destroy()
  }
}

Stimulus.register(`animation`, Animation)
